// Common + Asia/Middle-East currencies
export const CURRENCIES = [
  { code: "USD", label: "US Dollar", symbol: "$" },
  { code: "IDR", label: "Indonesian Rupiah", symbol: "Rp" },
  { code: "AED", label: "UAE Dirham (Abu Dhabi / Dubai)", symbol: "د.إ" },
  { code: "SAR", label: "Saudi Riyal", symbol: "﷼" },
  { code: "QAR", label: "Qatari Riyal", symbol: "﷼" },
  { code: "KWD", label: "Kuwaiti Dinar", symbol: "د.ك" },
  { code: "BHD", label: "Bahraini Dinar", symbol: ".د.ب" },
  { code: "OMR", label: "Omani Rial", symbol: "﷼" },
  { code: "INR", label: "Indian Rupee", symbol: "₹" },
  { code: "SGD", label: "Singapore Dollar", symbol: "S$" },
  { code: "MYR", label: "Malaysian Ringgit", symbol: "RM" },
  { code: "THB", label: "Thai Baht", symbol: "฿" },
  { code: "PHP", label: "Philippine Peso", symbol: "₱" },
  { code: "VND", label: "Vietnamese Dong", symbol: "₫" },
  { code: "CNY", label: "Chinese Yuan", symbol: "¥" },
  { code: "JPY", label: "Japanese Yen", symbol: "¥" },
  { code: "KRW", label: "South Korean Won", symbol: "₩" },
  { code: "HKD", label: "Hong Kong Dollar", symbol: "HK$" },
  { code: "PKR", label: "Pakistani Rupee", symbol: "₨" },
  { code: "BDT", label: "Bangladeshi Taka", symbol: "৳" },
  { code: "LKR", label: "Sri Lankan Rupee", symbol: "Rs" },
  { code: "AUD", label: "Australian Dollar", symbol: "A$" },
  { code: "EUR", label: "Euro", symbol: "€" },
  { code: "GBP", label: "British Pound", symbol: "£" },
];
